import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { PurposeCreationIntent } from '../../../../graphql/schema';
import { NameAndImage } from '../../NameAndImage';
import { nameAndImage } from '../../sharedSchemas';
import { useMajorPurchaseStep } from '../FlowConfig';

type FormValues = Yup.InferType<typeof nameAndImage>;

export const MajorPurchaseNameAndImageStep: React.FC = () => {
  const navigate = useNavigate();
  const { flowId } = useParams<{ flowId: string }>();

  const { commit } = useMajorPurchaseStep('nameAndImage');

  const handleSubmit = (formValues: FormValues) => {
    commit(formValues);
    void navigate(`/add_purpose/major_purchase/${flowId}/target_details`);
  };

  return <NameAndImage handleSubmit={handleSubmit} intent={PurposeCreationIntent.MajorPurchase} />;
};
